import {
  SET_IS_LOGGED_IN,
  SET_AUTH_TOKEN,
  SHOW_ALERT,
  HIDE_ALERT,
  SET_COMPANIES,
  SET_REMINDER_TYPES,
  SET_CURRENT_MESSAGES,
  SET_CURRENT_ROOM,
  SET_CURRENT_ROOMS_BY_FILTER,
  SET_CURRENT_ROOM_FILTER,
  SET_CURRENT_ROOM_SEARCH_TERM,
  SET_CURRENT_COMPANY,
  SET_CURRENT_COMPANY_OPERATORS,
  SET_CURRENT_OPERATOR,
  SET_TOTAL_UNREAD_COUNT,
  SET_DOCUMENT_TITLE_BASE,
  SET_NEW_VERSION_AVAILABLE,
  SET_WORK_HOURS_SCHEDULER_REASONS,
  SET_WORK_HOURS_SCHEDULER_IS_WORKING,
  SET_WORK_HOURS_SCHEDULER_CAN_SWITCH_OFF,
  SET_MOBILE_ROOM_MENU_ENABLED,
  SET_MOBILE_ROOM_INFO_ENABLED,
  SET_CURRENT_ROOMS_BY_SEARCH_TERM, SET_CASE_CLOSE_REASON,
} from './actions/actionTypes';

const authToken = localStorage.getItem('TOKEN'); // TODO: fix client-side auth security

export const initialState = {
  companies: [],                      // list of companies available to the current user
  currentCompany: {},                 // currently opened company (whose name's displayed next to logo in the top left)
  currentCompanyOperators: [],        // list of all operators of the "currentCompany"
  currentOperator: {},                // the operator who's currently logged in
  currentRoomFilter: 'all-rooms',     // the ID of the operator who's been selected in the <RoomFilter/>; or 'all-rooms'; or 'new-rooms'
  currentRoomSearchTerm: '',          // keyword entered into the room list search box by the user (if any)
  currentRoom: {},                    // currently opened room
  currentRoomsByFilter: [],           // list of all loaded rooms in the "currentCompany" in the left side menu
  currentRoomsBySearchTerm: [],       // list of all found rooms when the user types a search term into the room search field
  totalUnreadCount: 0,                // total number of unread messages in all rooms
  reminderTypes: [],                  // array of all types of reminders that can be set in the room (using "Create Task" button)
  reasonTypes: [],                    // массив причин завершения кейса
  schedulerReasons: [],               // array of possible reasons to choose when operator's taking unscheduled break
  alerts: [],                         // array of all currently visible alerts (such as error messages)
  messages: [],                       // array of all loaded messages in the "currentRoom"
  documentTitleBase: '',              // current document.title text w/o unread counter
  newVersionAvailable: '',            // a string (e.g. "3.1.2") indicating that there is a new version available
  workHoursSchedulerIsWorking: true,  // indicates whether the green switcher in Header is currently on
  workHoursSchedulerCanSwitchOff: true,
  workHoursSchedulerReasons: [],      // list of reasons/options of why operator can take a break
  isMobileMenuEnabled: false,         // indicates if left-side menu is visible ("sandwich" icon in top-left on mobile)
  isMobileSidebarEnabled: false,      // indicates if right-side sidebar (such as room details) is visible ("✕" icon in top-left on mobile)
  authToken,                          // auth token returned by getAuthTokenByEmailAndPassword() (in /services/apiGlobal.js) which however may be expired
  isLoggedIn: false,                  // boolean indicating whether the user is logged it (meaning has a valid non-expired authToken)
  currentRoomQueue: 'in-work',
};


export function commonReducer(state, action){
  switch (action.type) {
  // Login
  case SET_IS_LOGGED_IN:
  case SET_AUTH_TOKEN:

    // Companies & operators
  case SET_COMPANIES:
  case SET_CURRENT_COMPANY:
  case SET_CURRENT_COMPANY_OPERATORS:
  case SET_CURRENT_OPERATOR:

    // Rooms
  case SET_CURRENT_ROOM:
  case SET_CURRENT_ROOM_FILTER:
  case SET_CURRENT_ROOM_SEARCH_TERM:
  case SET_CURRENT_ROOMS_BY_FILTER:
  case SET_CURRENT_ROOMS_BY_SEARCH_TERM:

    // Schedule & switcher
  case SET_WORK_HOURS_SCHEDULER_REASONS:
  case SET_WORK_HOURS_SCHEDULER_IS_WORKING:
  case SET_WORK_HOURS_SCHEDULER_CAN_SWITCH_OFF:

    // Messages
  case SET_CURRENT_MESSAGES:
  case SET_REMINDER_TYPES:
  case SET_TOTAL_UNREAD_COUNT:
  case SET_CASE_CLOSE_REASON:

    // UI
  case SET_DOCUMENT_TITLE_BASE:
  case SET_NEW_VERSION_AVAILABLE:
  case SET_MOBILE_ROOM_MENU_ENABLED:
  case SET_MOBILE_ROOM_INFO_ENABLED: {
    return {
      ...action.payload,
    };
  }
  }
}

export function alertReducer(state, action){
  switch (action.type) {
  case SHOW_ALERT: {
    const alerts = [...state.alerts, action.payload];
    return {
      alerts,
    };
  }
  case HIDE_ALERT: {
    const alerts = state.alerts.filter(alert => {
      return alert.id !== action.payload.alertId;
    });
    return {
      alerts,
    };
  }
  }
}

export function rootReducer(state = initialState, action){
  return {
    ...state,
    ...commonReducer(state, action),
    ...alertReducer(state, action),
  };
}
